// https://w.amazon.com/bin/view/INTech/Panther/I18nFamily#Hadvertising
const locales = ['en-US', 'ar-AE', 'cs-CZ', 'de-DE', 'en-AU', 'en-CA', 'en-GB', 'en-IN', 'en-SG', 'es-ES', 'es-MX', 'fr-CA', 'fr-FR', 'he-IL', 'hi-IN', 'it-IT', 'ja-JP', 'ko-KR', 'nl-NL', 'pl-PL', 'pt-BR', 'th-TH', 'tr-TR', 'sv-SE', 'vi-VN', 'zh-CN', 'zh-TW'];

export { locales as l };
//# sourceMappingURL=locales-DbFLN74b.js.map
